import { useEffect } from 'react';
import LandingNav from './components/LandingNav';
import HeroSection from './sections/HeroSection';
import FeaturesSection from './sections/FeaturesSection';
import HowItWorksSection from './sections/HowItWorksSection';
import PricingSection from './sections/PricingSection';
import FAQSection from './sections/FAQSection';
import CTASection from './sections/CTASection';
import './LandingPage.css';

export default function LandingPage() {
  const supportUrl = 'https://x.com/coldestlin';

  useEffect(() => {
    // Set up intersection observer for scroll animations
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe all animatable elements
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Smooth scroll handler for navigation links
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="landing-page">
      <LandingNav onNavClick={handleNavClick} />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-logo">🦀</span>
            <span className="footer-name">Clawee</span>
          </div>
          <p className="footer-tagline">Your Personal AI Agent in the Cloud</p>
          <p className="footer-support">
            Need help? DM us on X:
            {' '}
            <a
              href={supportUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-support-link"
            >
              Contact Support
            </a>
          </p>
          <p className="footer-copyright">&copy; {new Date().getFullYear()} Clawee. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
